import red from "@material-ui/core/colors/red";

export default theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },
  questionFormContainer: {
    ...theme.mixins.gutters(),
    maxWidth: "50%",
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  reviewButtonsContainer: { display: "flex", justifyContent: "space-between", marginTop: theme.spacing(3) },
  submitNewQuestionButtonContainer: { display: "flex", justifyContent: "center", marginTop: theme.spacing(3) },
  tableWithQuestionsContainer: { maxWidth: "100%" },
  dangerHelperText: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  dangerColor: {
    color: red[500]
  },
  textToSpeechButton: {
    marginLeft: "0.6rem",
    paddingTop: "1px",
    paddingBottom: "1px"
  },
  textToSpeechIconInButton: {
    marginRight: "0.3rem"
  },
  deleteQuestionButton: {
    color: "white",
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700]
    }
  }
});
